import apis from '@/apis';
import { RESET_DATA_PANEL } from './constants';
import { FETCH_QUERYCONDITIONS_INFO } from './filter-box';
export const QUERY_REAL_ACTIVITY_PLAN = 'QUERY_REAL_ACTIVITY_PLAN';
export const HAVE_RIGHT_TO_VIEW_ACTIVITY_DATA = 'haveRightToViewActivityData';
export const QUERY_ACTIVITY_LOADING = 'QUERY_ACTIVITY_LOADING';
export const RESET_REAL_PLAN_DATA = 'RESET_REAL_PLAN_DATA';
export const queryRealActivityPlanDataAll = (data) => (dispatch, getState) => {
  // const { startTime, endTime } = data
  dispatch({
    type: QUERY_ACTIVITY_LOADING,
    payload: true,
  });
  const param = Object.assign(
    {},
    { startTime: data.startTime },
    { endTime: data.endTime },
    { plant: data.channel },
    { planCode: data.activityCode }
  );
  apis.queryRealActivityPlanDataAll(param).then((res) => {
    if (res && res.ret === '0') {
      res.data && res.data.viewClick && res.data.viewClick.push({});
      dispatch({
        type: QUERY_REAL_ACTIVITY_PLAN,
        payload: res.data,
      });
    } else {
      dispatch({
        type: QUERY_REAL_ACTIVITY_PLAN,
        payload: {},
      });
    }
    if (res && res.ret === '9') {
      dispatch(haveRightToViewActivityData());
    }
  });
};

export const resetRealPlanData = function () {
  console.log('走没走啊啊dsdssdsdsd');
  return {
    type: 'RESET_REAL_PLAN_DATA',
  };
};
export const haveRightToViewActivityData = function (payload) {
  return {
    type: HAVE_RIGHT_TO_VIEW_ACTIVITY_DATA,
    payload,
  };
};

const initialState = {
  // 是否有查看当前活动的权限
  haveRightToViewActivityData: true,

  viewClick: [
    { k: '页面访问PV' },
    { k: '页面访问UV' },
    { k: '点击次数' },
    { k: '点击人数' },
    { k: '人均浏览量' },
    { k: 'UV跳失率' },
    { k: '引流商详PV' },
    { k: '引流商详UV' },
    { k: '商详到达率' },
    {},
  ],
  rebuyInfo: [],
  dealTrans: [{ k: '成交订单数' }, { k: '成交订单金额' }, { k: '成交商品数' }, { k: '成交转化率' }],
  flowEfficiency: [{ k: '客单价' }, { k: 'UV价值' }],
  activityPlanDataDetailList: [],
  saleTarget: 0,
  realSale: '',
  completeRate: 0,
  loading: false,
  downloadUrl: '',
};

export default function realActivityPlan(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case QUERY_REAL_ACTIVITY_PLAN:
      return Object.assign({}, state, payload, {
        loading: false,
      });
    case HAVE_RIGHT_TO_VIEW_ACTIVITY_DATA:
      return Object.assign({}, state, { haveRightToViewActivityData: payload });
    case RESET_DATA_PANEL:
      return initialState;
    case FETCH_QUERYCONDITIONS_INFO:
      // 切换活动查询则重置权限
      return initialState;
    case RESET_REAL_PLAN_DATA:
      return initialState;
    case QUERY_ACTIVITY_LOADING:
      return Object.assign({}, state, payload);
    default:
      return state;
  }
}
